import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { generateTokenFn, resolveTextStyleValue } from './tokens';
/**
 * Create style keys for a specific `textStyle.*` token, to be spread
 * onto any style object within `StyleSheet`
 * @param {String} key
 * @return {Object}
 */

export var text = {
  styles: function styles() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref.target,
        fallback = _ref.fallback,
        color = _ref.color,
        font = _ref.font,
        lineHeight = _ref.lineHeight,
        letterSpacing = _ref.letterSpacing,
        textDecoration = _ref.textDecoration;

    var shared = {
      target: target,
      tokenKey: 'textStyle',
      resolver: resolveTextStyleValue
    };

    var _ref2 = font || {},
        family = _ref2.family,
        size = _ref2.size,
        weight = _ref2.weight;

    return {
      color: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'color',
        fallback: [color, fallback]
      })),
      fontFamily: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'font.family',
        fallback: [family, fallback]
      })),
      fontSize: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'font.size',
        fallback: [size, fallback]
      })),
      fontWeight: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'font.weight',
        fallback: [weight, fallback]
      })),
      lineHeight: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'lineHeight',
        fallback: [lineHeight, fallback]
      })),
      letterSpacing: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'letterSpacing',
        fallback: [letterSpacing, fallback]
      })),
      textDecoration: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'textDecoration',
        fallback: [textDecoration, fallback]
      }))
    };
  },
  tokens: function tokens() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        target = _ref3.target,
        fallback = _ref3.fallback,
        color = _ref3.color,
        font = _ref3.font,
        lineHeight = _ref3.lineHeight,
        letterSpacing = _ref3.letterSpacing,
        textDecoration = _ref3.textDecoration;

    var shared = {
      target: target,
      tokenKey: 'textStyle',
      resolver: resolveTextStyleValue
    };

    var _ref4 = font || {},
        family = _ref4.family,
        size = _ref4.size,
        weight = _ref4.weight;

    return {
      color: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'color',
        fallback: [color, fallback]
      })),
      font: {
        family: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'font.family',
          fallback: [family, fallback]
        })),
        size: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'font.size',
          fallback: [size, fallback]
        })),
        weight: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
          type: 'font.weight',
          fallback: [weight, fallback]
        }))
      },
      lineHeight: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'lineHeight',
        fallback: [lineHeight, fallback]
      })),
      letterSpacing: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'letterSpacing',
        fallback: [letterSpacing, fallback]
      })),
      textDecoration: generateTokenFn(_objectSpread(_objectSpread({}, shared), {}, {
        type: 'textDecoration',
        fallback: [textDecoration, fallback]
      }))
    };
  }
};